import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash_active",
  "use": "trash_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"trash_active\"><g fill-rule=\"evenodd\"><path d=\"M13 3v1H7V3h6Zm0 0c0-.6-.4-1-1-1H8c-.6 0-1 .4-1 1v1H4c-.6 0-1 .4-1 1h1v11c0 1 1 2 2 2h8c1 0 2-1 2-2V5h1c0-.6-.4-1-1-1h-3V3ZM8 8h1v6H8V8Zm3 0h1v6h-1V8Z\" opacity=\".9\" /><path d=\"M3 4h14v1H3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol